// Small DOM helpers shared by every playground.

const SVG = 'http://www.w3.org/2000/svg';

export function el( tag, attrs = {}, children = [] ) {

	const node = document.createElement( tag );
	for ( const [ key, value ] of Object.entries( attrs ) ) {

		if ( value == null || value === false ) continue;
		if ( key === 'text' ) node.textContent = value;
		else if ( key === 'hidden' ) node.hidden = true;
		else if ( key === 'disabled' ) node.disabled = true;
		else node.setAttribute( key, value );

	}

	for ( const child of children ) if ( child != null ) node.append( child );
	return node;

}

export function icon( shape ) {

	const node = document.createElementNS( SVG, 'svg' );
	node.setAttribute( 'viewBox', '0 0 16 16' );
	node.setAttribute( 'aria-hidden', 'true' );
	const part = document.createElementNS( SVG, shape.tag );
	for ( const [ key, value ] of Object.entries( shape.attrs ) ) part.setAttribute( key, value );
	node.append( part );
	return node;

}

export const ICONS = {
	run: { tag: 'path', attrs: { d: 'M4.5 3v10l8-5z', fill: 'currentColor' } },
	stop: { tag: 'rect', attrs: { x: '4', y: '4', width: '8', height: '8', rx: '1', fill: 'currentColor' } },
	clear: { tag: 'path', attrs: { d: 'M3 5h10M6 5V3.5h4V5M5 5l.6 8h4.8L11 5', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.4', 'stroke-linejoin': 'round' } },
	scripts: { tag: 'path', attrs: { d: 'M2.5 3.5h3M5 3.5v9M5 8h3.5M5 12.5h3.5M10 3.5h3.5M10 8h3.5M10 12.5h3.5', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.4', 'stroke-linecap': 'round' } },
	model: { tag: 'path', attrs: { d: 'M8 2l5.5 3v6L8 14l-5.5-3V5zM2.5 5L8 8l5.5-3M8 8v6', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.3', 'stroke-linejoin': 'round' } },
	file: { tag: 'path', attrs: { d: 'M4 2h5l3 3v9H4zM9 2v3h3', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.3', 'stroke-linejoin': 'round' } },
	editor: { tag: 'path', attrs: { d: 'M5.5 4L2 8l3.5 4M10.5 4L14 8l-3.5 4', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.4', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' } },
	terminal: { tag: 'path', attrs: { d: 'M2.5 4.5L6 8l-3.5 3.5M8 12h5.5', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.4', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' } },
	chevron: { tag: 'path', attrs: { d: 'M6 4l4 4-4 4', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.5', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' } },
	close: { tag: 'path', attrs: { d: 'M4 4l8 8M12 4l-8 8', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.5', 'stroke-linecap': 'round' } },
};

/** Load a classic script. UMD builds (Emscripten, Monaco's loader) need this. */
export function loadScript( src ) {

	return new Promise( ( resolve, reject ) => {

		const script = document.createElement( 'script' );
		script.src = src;
		script.onload = resolve;
		script.onerror = () => reject( new Error( `Failed to load ${ src }` ) );
		document.head.appendChild( script );

	} );

}
